import { useEffect, useState } from "react";
import "./ScoreCardProgressBar.css";

interface ScoreCardProgressBarProps {
  progress: number;
}

const ScoreCardProgressBar: React.FC<ScoreCardProgressBarProps> = ({
  progress,
}) => {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    setAnimatedProgress(0);
    const timer = setTimeout(() => {
      setAnimatedProgress(progress);
    }, 100);
    return () => clearTimeout(timer);
  }, [progress]);

  return (
    <div className="score-card-progress-container">
      <div className="progress-label">{progress}%</div>
      <div className="progress-bar">
        <div className="progress-track">
          <div
            className="progress-fill"
            style={{ width: `${animatedProgress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ScoreCardProgressBar;
